import React from 'react';

import {WorkspaceDetails} from 'src/openapi/admin/models/WorkspaceDetails';

import {Group} from '@pb/kit-component-group';
import {Icon, Icons, type SingleColor, Sizes} from '@pb/kit-component-icon';

type Props = {
    workspaceDetails?: WorkspaceDetails,
    minWidth?: number | string,
};

type WorkspaceCountItem = {
    icon: typeof SingleColor[keyof typeof SingleColor],
    label: string,
    count?: number,
};

export const WorkspaceDropdownContent = ({workspaceDetails, minWidth = 200}: Props) => {
    const workspaceItems: WorkspaceCountItem[] = [
        {
            icon: Icons.SAVED_SEARCH,
            label: 'Saved Searches',
            count: workspaceDetails?.worksItemCounts?.searchesCount,
        },
        {
            icon: Icons.LIST_ALT,
            label: 'Saved Lists',
            count: workspaceDetails?.worksItemCounts?.listsCount,
        },
        {
            icon: Icons.MAP,
            label: 'Market Maps',
            count: workspaceDetails?.worksItemCounts?.marketMapsCount,
        },
        {
            icon: Icons.MARKET_ANALYSIS,
            label: 'Verticals',
            count: workspaceDetails?.worksItemCounts?.analystCuratedSearchesCount,
        },
        {
            icon: Icons.EXPANDED_EQUITY_RESEARCH,
            label: 'Research',
            count: workspaceDetails?.worksItemCounts?.reportsCount,
        },
        {
            icon: Icons.FILE_CODE_O,
            label: 'Files',
            count: workspaceDetails?.worksItemCounts?.fileCount,
        },
        {
            icon: Icons.EXTERNAL_LINK,
            label: 'External Links',
            count: workspaceDetails?.worksItemCounts?.linksCount,
        },
    ];

    return (
        <div style={{minWidth, minHeight: 75}}>
            {
                workspaceItems.map((item, index) => (
                    <Group
                        display="flex"
                        justify="space-between"
                        key={item.label}
                        style={{
                            backgroundColor: index % 2 === 0 ? 'transparent' : '#f5f5f5',
                        }}>
                        <Group gap="s" style={{marginRight: 8, display: 'flex', alignItems: 'center', justifyContent: 'flex-start'}}>
                            <div style={{width: 10}}>
                                <Icon type={item.icon} size={Sizes.Size_12}/>
                            </div>
                            <strong style={{width: 100}}>{item.label}:</strong>
                        </Group>
                        {item.count && item.count > 0 ? item.count : '--'}
                    </Group>
                ))
            }
        </div>
    );
};
